import { render, staticRenderFns } from "./VueCardCarousel.vue?vue&type=template&id=7ff55f18&scoped=true&"
import script from "./VueCardCarousel.vue?vue&type=script&lang=js&"
export * from "./VueCardCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VueCardCarousel.vue?vue&type=style&index=0&id=7ff55f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff55f18",
  null
  
)

export default component.exports